import { Component } from 'preact';
import { route } from 'preact-router';
import { translate } from 'react-i18next';

import Button from '../Button.js';


class AddReferrer extends Component {

	cancelEmailChange = () => {
		route('/', true);
	};

	validateForm = (refer, game) => {
		this.setState({
			errorReferralAdd: undefined
		});
		if (!refer) {
			this.setState({ errorReferralAdd: 'A referring player is required.' });
      return false;
    }
    if (game === 'None') {
			this.setState({ errorReferralAdd: 'You must select a game.' });
      return false;
    }
		return true;
	}

	submitAddReferrer = (e) => {
		this.setState({ buttonEmailChange: 'loading' });
		if (this.validateForm(this.state.refer, this.state.game)) {
			fetch('https://api.hirezstudios.com/acct/addReferrer', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"webToken": "${this.props.userData.webToken}", "playerName": "${this.state.refer}", "game": "${this.state.game}"}`
			}).then((response) => response.json()).then((response) => {
				this.setState({ buttonEmailChange: 'initial' });
				if (response.statusCode !== 200) {
					this.setState({ errorReferralAdd: 'Referrer cannot be added for accounts greater than 10 days old or account does not exist.' });
				}
 		    else {
					this.props.notification('success', 10000, `You've successfully added ${response.body.playerName} as a referring player!`);
					this.setState({
						refer: undefined,
						game: 'None'
					});
				}
			});
		}
		else {
			this.setState({ buttonEmailChange: 'initial' });
		}
	}


	constructor(props) {
		super(props);
		this.state = {
      refer: undefined,
      game: 'None',
      errorReferralAdd: undefined,
      buttonEmailChange: 'initial'
		};
	}

	render() {
		const {
			userData,
			t
		} = this.context;
		return (
			<div className="add-referrer">
        <h1>{t('Add Referrer')}</h1>
        <div className="error-new-email">
          {t(this.state.errorReferralAdd)}
        </div>
				<form>
					<label for="player-name">{t('Referring Player\'s Name')}</label>
					<input
						id="player-name"
						type="text"
						onInput={e => this.setState({ refer: e.target.value })}
						value={t(this.state.refer)}
					/>
          <label for="player-name">{t('Game')}</label>
          <select onChange={e => this.setState({ game: e.target.value })} id="2fa-frequency" value={this.state.game}>
            <option default disabled value="None">{t('Select A Game')}</option>
            <option value="Smite">{t('Smite')}</option>
            <option value="Paladins">{t('Paladins')}</option>
          </select>
					<div className="buttons">
						<Button
							color="blue"
							copy={t('Submit')}
							state={this.state.buttonEmailChange}
							onClick={this.submitAddReferrer}
						/>
						<Button
							color="white"
							copy={t('Cancel')}
							onClick={this.cancelEmailChange}
						/>
					</div>
				</form>
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(AddReferrer);



// WEBPACK FOOTER //
// ./components/views/AddReferrer.js